import { useState } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';
import { parseDoubleEncodedJson } from '../../utils/apiHelpers';

interface UpdateUrlPayload {
    ent_entity_url_id: string | number;
    url: string;
    url_type_id?: string | number;
}

const useUpdateUrl = () => {
    const { authFetch, isReady, workspaceId } = useAuthenticatedFetchWithWorkspace();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string>('');

    const updateUrl = async (payload: UpdateUrlPayload): Promise<any> => {
        if (!isReady || !workspaceId) {
            setError('Workspace not ready');
            return null;
        }

        setIsLoading(true);
        setError('');
        try {
            const { ent_entity_url_id, ...updateData } = payload;
            const result = await authFetch('/updateEntEntityUrl', {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ent_entity_url_id, ...updateData }),
            });

            return parseDoubleEncodedJson(result) || { success: true };
        } catch (err: unknown) {
            const message = err instanceof Error ? err.message : 'Unknown error while updating the URL.';
            console.error('[useUpdateUrl] failed:', { workspaceId, payload, message });
            setError(message);
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    return { updateUrl, isLoading, error };
};

export default useUpdateUrl;
